export default __webpack_public_path__ + "static/media/avatar.c795cf44.jpg";